import React from 'react';
import { Home, BookOpen, BarChart2, Award, Settings, Plus } from 'lucide-react';
export function BottomNavigation() {
  return <div className="md:hidden fixed bottom-0 left-0 right-0 bg-white border-t border-gray-200 shadow-lg z-30" data-id="element-195">
      <div className="flex items-center justify-around py-3" data-id="element-196">
        <NavButton icon={<Home size={20} data-id="element-198" />} label="Home" active data-id="element-197" />
        <NavButton icon={<Plus size={20} data-id="element-200" />} label="Add Skills" data-id="element-199" />
        <NavButton icon={<BarChart2 size={20} data-id="element-202" />} label="Analytics" data-id="element-201" />
        <NavButton icon={<Award size={20} data-id="element-204" />} label="Awards" data-id="element-203" />
        <NavButton icon={<Settings size={20} data-id="element-206" />} label="Settings" data-id="element-205" />
      </div>
    </div>;
}
interface NavButtonProps {
  icon: React.ReactNode;
  label: string;
  active?: boolean;
}
function NavButton({
  icon,
  label,
  active = false
}: NavButtonProps) {
  return <button className={`flex flex-col items-center gap-1.5 min-w-[60px] py-1.5 transition-colors ${active ? 'text-red-600' : 'text-gray-600'}`} data-id="element-207">
      <div className={`${active ? 'text-red-600' : 'text-gray-600'}`} data-id="element-208">
        {icon}
      </div>
      <span className="text-[10px] font-medium leading-tight" data-id="element-209">{label}</span>
    </button>;
}